import { ApiError } from '@clockwise/shared';

/**
 * True when a thrown error is an API `403 Forbidden`. The Customer area returns
 * this when a caller with `customer.view`/`customer.edit` scoped to `assigned`
 * reaches a customer (or its SOW/contacts/team) they aren't a member of — the
 * UI renders a "Not Authorized" panel instead of a generic load error.
 */
export function isForbidden(err: unknown): boolean {
  return err instanceof ApiError && err.httpStatus === 403;
}

/**
 * What went wrong, in the words that help.
 *
 * G15: a failed save must be visible, and it must say something. For a
 * VALIDATION_ERROR the envelope's own `message` is the generic "Validation
 * failed" and the useful sentence is on the FIELD — which is how an unnamed
 * save came to be reported as "Validation failed" with no mention of a name.
 * The field's message wins wherever there is one; a CONFLICT carries none and
 * its message already names what it collided with. Anything that is not an
 * `ApiError` (a network failure, a bug) gets the caller's `fallback`.
 */
export function apiErrorText(err: unknown, fallback: string): string {
  if (!(err instanceof ApiError)) return fallback;
  return err.fields?.[0]?.message ?? err.message;
}
